import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { concatMap, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '@core/services/auth.service';
import * as AppActions from './app.actions';
import { loadExhibitions } from '@app/exhibition/_ngrx/exhibition.actions';
import { loadTours } from '@app/tour/_ngrx/tour.actions';
import { loadContents } from '@app/content/_ngrx/content.actions';
import { loadStations } from '@app/station/_ngrx/station.actions';
import { SyncService } from '../services/sync.service';
import { OrganizationService } from '../services/organization.service';
import { AppService } from '../services/app.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppEffects {
  private readonly actions$ = inject(Actions);
  private readonly authService = inject(AuthService);
  private readonly syncService = inject(SyncService);
  private readonly organizationService = inject(OrganizationService);
  private readonly appService = inject(AppService);

  useSync: boolean = true;

  login = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/effects/init'),
      switchMap(() => this.authService.getToken()),
      map(token => AppActions.setToken({ token }))
    )
  );

  getData: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.setToken),
      tap(() => {
        this.organizationService.getOrganizationWithSuffix(environment.urlSuffix);
        this.organizationService.getOrganizationDetailWithSuffix(environment.urlSuffix);

      }),
      concatMap(() => !this.useSync ? [
        loadExhibitions(),
        loadTours(),
        loadStations(),
        loadContents()
      ] : []),
    )
  );

  setOrganization: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.setOrganization),
      tap(payload => {
        const organization = payload.organization;

        if (this.useSync) {
          this.syncService.getSyncMetaInfo(payload.organization);
        }

        this.appService.fillOrganizationFields(organization);
      })
    ), {dispatch: false}
  );
}
